import CreateEventForm from './CreateEventForm';

export default CreateEventForm;
